$(document).ready(function() {
  var orangeBar     = $('#orange-bar').innerHeight();
  var pageContainer = $('#oc-container');
  var navWrapper    = $('#nav');
  var ocIcon        = $('#oc-icon');
  var ocUtil        = $('#oc-utility');

  pageContainer.css('top', orangeBar + 'px');
  // navWrapper.css('top', orangeBar + 'px'); default
  ocIcon.css('top', (orangeBar + 17) + 'px');
  ocUtil.css('top', orangeBar + 'px');

  /*----------  Off Canvas Utilities  ----------*/
  $('#oc-icon').stop().click(function() {
    $('.oc-js').toggleClass('active');
    $('.nav-bars').toggleClass('m-nav-open');
    $('#orange-bar').toggleClass('');
  });

  $('#oc-icon').stop().on('keydown', function(event) {
    if (event.which === 13) {
      $('.oc-js').toggleClass('active');
      $('.nav-bars').toggleClass('m-nav-open');
      $('#orange-bar').toggleClass('');
      $('.m-nav .first-lvl').first().find('>a').focus();

      document.addEventListener('focusin', onFocus);

      function onFocus(e) {
        if(!$('.m-nav').find(e.target).length) {
          $('.oc-js').toggleClass('active');
          $('.nav-bars').toggleClass('m-nav-open');
          $('#orange-bar').toggleClass('');
          document.removeEventListener('focusin', onFocus);
        }
      }
    }
  });

  $('span.oc-toggle').on('click', function(e) {
    e.preventDefault();
    $(this).next('ul').stop().slideToggle();
    if ($(this).hasClass('plus')) {
      $(this).stop().removeClass('plus').addClass('minus');
      
    } else {
      $(this).stop().removeClass('minus').addClass('plus');
      
    }
  });

  $('span.oc-toggle').on('keydown', function(event) {
    if (event.which === 13) {
      $(this).next('ul').stop().slideToggle();
      if ($(this).hasClass('plus')) {
        $(this).stop().removeClass('plus').addClass('minus');
      } else {
        $(this).stop().removeClass('minus').addClass('plus');
      }
    }
  });

  $("#nav a, #nav .second-lvl, #nav .third-lvl").focus(function() {
    $(this).parents(".first-lvl").addClass("focus");
    $(this).parents(".first-lvl").addClass("do-not-remove");
  }).blur(function() {
    $(this).parents(".first-lvl").addClass("removal-scheduled");
    if (!$(this).parents(".first-lvl").hasClass('do-not-remove')) {
      $(".first-lvl").removeClass("focus");
    } else {
      $(this).parents(".first-lvl").removeClass("do-not-remove");
    }
    setTimeout(function () {
      if (!$(".first-lvl").hasClass('do-not-remove')) {
        $(".first-lvl").removeClass("focus");
      }
    }, 200);
  });
  $("#nav a").keydown(function(e) {
    if(e.keyCode == 37) { // left
      $(this).blur();
      const prev = $(this).closest('.first-lvl').prev();
      setTimeout(function () {
        prev.find(">a").focus();
      }, 500);
    }
    else if(e.keyCode == 39) { // right
      $(this).blur();
      const next = $(this).closest('.first-lvl').next();
      setTimeout(function () {
        next.find(">a").focus();
      }, 500);
    }
  });
});


/**
 *
 * Window Resize Functions
 *
 **/

$(window).resize(function() {
  var orangeBar     = $('#orange-bar').innerHeight();
  var pageContainer = $('#oc-container');
  var navWrapper    = $('#nav');
  var ocIcon        = $('#oc-icon');
  var ocUtil        = $('#oc-utility');

  pageContainer.css('top', orangeBar + 'px');
  navWrapper.css('top', orangeBar + 'px');
  ocIcon.css('top', (orangeBar + 12) + 'px');
  ocUtil.css('top', orangeBar + 'px');
  
  /*----------  Off Canvas Menu Hide  ----------*/
  var windowWidth = $(window).innerWidth();

  if (windowWidth >= 768) {
    $('.oc-js').removeClass('active');
    $('span.oc-toggle').each(function() {
      // $(this).removeClass('minus').addClass('plus');
      $(this).next('ul').css('display', '');
    });
  } 
});



window.onscroll = function() {
  var nav = document.getElementById("nav");
  
}